import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// Users list - powers the manager picker on the New / Edit Event modals.
// Cached for 5 minutes: the list changes only when someone new signs in for
// the first time (or an admin toggles is_active), so a short staleTime is a
// good balance between freshness and avoiding refetches every keystroke in
// the picker.
export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: ApiClient.users,
    staleTime: 5 * 60 * 1000
  })
}
